import React from 'react'
import { Route } from 'react-router-dom'
import { KpisView, DatasetView } from 'components/MetricsView'

const Metrics = ({ match }) => (
  <div>
    <Route path={`${match.path}/panels`} component={KpisView} />
    <Route path={`${match.path}/datasets`} component={DatasetView} />
  </div>
)

export default Metrics
